import * as React from "react"
import { FiInfo } from "react-icons/fi"
import * as styles from "./styles.css"
import clsx from "clsx"

export type InfoLinkProps = {
  url: string
  title?: string
  className?: string
}

export function InfoLink({ url, title = ``, className }: InfoLinkProps) {
  return (
    <a
      href={url}
      title={title}
      className={clsx(styles.root, className)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FiInfo aria-hidden="true" />
    </a>
  )
}
